import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { NexusService } from 'global-apis/nexus-service'
import {Color, Vehicle} from '@nxcr-org/web-api-interface/lib/vehicle_pb'
import { Vehicle as FleetVehicle } from '@nxcr-org/web-api-interface/lib/fleet_service_pb'

interface EditVehicleData {
  exteriorColor: string
  make: string
  model: string
  financier: string
}

export function useEditVehicle(vehicle?: FleetVehicle.AsObject) {
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false)
  const queryClient = useQueryClient()

  const updateVehicleMutation = useMutation({
    mutationFn: async (data: EditVehicleData) => {
      if (!vehicle?.id) {
        throw new Error('Vehicle ID is required')
      }
      const newVehicle = new Vehicle()
      newVehicle.setId(vehicle.id)
      newVehicle.setMake(data.make)
      newVehicle.setModel(data.model)
      const exteriorColor = new Color()
      exteriorColor.setTitle(data.exteriorColor)
      newVehicle.setExteriorColorsList([exteriorColor])
      newVehicle.setFinancier(data.financier)
      console.log(newVehicle)
      return NexusService.updateVehicle({
        vehicle: newVehicle,
      })
    },
      onSuccess: () => {
        // Invalidate and refetch vehicle data
        if (vehicle?.id) {
          queryClient.invalidateQueries({queryKey: ['getVehicle', vehicle?.id]})
        }
        setIsEditDrawerOpen(false)
      },
      onError: (error) => {
        console.error('Failed to update vehicle:', error)
      }
    }
  )

  const handleSave = (data: EditVehicleData) => {
    updateVehicleMutation.mutate(data)
  }

  const getDefaultValues = () => ({
    exteriorColor: vehicle?.exteriorColor || '',
    make: vehicle?.make || '',
    model: vehicle?.model || '',
    financier: vehicle?.financier || ''
  })

  return {
    isEditDrawerOpen,
    setIsEditDrawerOpen,
    handleSave,
    getDefaultValues,
    isLoading: updateVehicleMutation.status === 'pending'
  }
}
